module.exports = __webpack_public_path__ + "static/media/usa-flag.f30c9282.png";